export default "__VITE_PUBLIC_ASSET__d690b5d0__"